module.exports = __webpack_public_path__ + "static/media/reactjs.3ac31aee.svg";